export default [
    {
        path: "/appeals/my-appeals",
        name: "my-appeals",
        meta: { title: "my-appeals", authRequired: true },
        component: () => import("../views/appeals/my-appeals.vue"),
    },
    {
        path: "/appeals/create-appeal",
        name: "create-appeal",
        meta: { title: "create-appeal", authRequired: true },
        component: () => import("../views/appeals/create-appeal.vue"),
    },
    {
        path: "/appeals/view-appeal",
        name: "view-appeal",
        meta: { title: "view-appeal", authRequired: true },
        component: () => import("../views/appeals/view-appeal.vue"),
    },
    {
        path: "/appeals/appeal-decision",
        name: "appeal-decision",
        meta: { title: "appeal-decision", authRequired: true },
        component: () => import("../views/appeals/appeal-decision.vue"),
    }
]
